module.exports = __webpack_public_path__ + "images/psp/Bicycle/bicycle-hero-size.png";